import { PUSH_ERROR, CLEAR_ERRORS } from '#action/types';

const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case PUSH_ERROR: {
      return [...state, action.payload];
    }
    case CLEAR_ERRORS:
      return defaultState;
    default:
      return state;
  }
};
